import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

type ProtectedRouteProps = {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireTenant?: boolean;
  requirePartner?: boolean;
};

export const ProtectedRoute = ({
  children,
  requireAdmin = false,
  requireTenant = false,
  requirePartner = false
}: ProtectedRouteProps) => {
  const { isAuthenticated, isAdmin, isTenantUser, isPartnerUser, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  if (requireTenant && !isTenantUser) {
    return <Navigate to="/login" replace />;
  }

  if (requirePartner && !isPartnerUser) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
